module.exports = __webpack_public_path__ + "static/media/medial-nonflexion-up-1.0738311b.png";